import { useColorModeValue } from '@chakra-ui/react';

export const folderColorProvider = (color, alpha = 1, brightness = 0) => {
    const adjustBrightness = (rgb, brightness) => {
        let [r, g, b] = rgb.split(', ').map(Number);
        r = Math.max(0, Math.min(255, r - brightness));
        g = Math.max(0, Math.min(255, g - brightness));
        b = Math.max(0, Math.min(255, b - brightness));
        return `${r}, ${g}, ${b}`;
    };

    const greyColor = adjustBrightness(
        //Changed light gray from from native: 96, 100, 106
        useColorModeValue('122, 126, 133', '218, 220, 224'),
        brightness
    );
    const blueColor = adjustBrightness(
        useColorModeValue('27, 115, 232', '138, 180, 247'),
        brightness
    );
    const redColor = adjustBrightness(
        useColorModeValue('217, 48, 37', '242, 139, 130'),
        brightness
    );
    const yellowColor = adjustBrightness(
        useColorModeValue('250, 171, 0', '254, 213, 99'),
        brightness
    );
    const greenColor = adjustBrightness(
        useColorModeValue('23, 128, 56', '129, 201, 149'),
        brightness
    );
    const pinkColor = adjustBrightness(
        useColorModeValue('208, 23, 131', '255, 139, 203'),
        brightness
    );
    const purpleColor = adjustBrightness(
        useColorModeValue('161, 66, 244', '197, 137, 249'),
        brightness
    );
    const cyanColor = adjustBrightness(
        useColorModeValue('2, 123, 131', '120, 217, 236'),
        brightness
    );
    const orangeColor = adjustBrightness(
        useColorModeValue('250, 144, 62', '252, 173, 112'),
        brightness
    );
    const noneColor = adjustBrightness(
        useColorModeValue('71, 92, 104', '113, 124, 131'),
        brightness
    );

    let folderColor =
        color === 'grey'
            ? greyColor
            : color === 'blue'
            ? blueColor
            : color === 'red'
            ? redColor
            : color === 'yellow'
            ? yellowColor
            : color === 'green'
            ? greenColor
            : color === 'pink'
            ? pinkColor
            : color === 'purple'
            ? purpleColor
            : color === 'cyan'
            ? cyanColor
            : color === 'orange'
            ? orangeColor
            : noneColor;
    let colorToReturn = 'rgba(' + folderColor + ', ' + alpha + ')';
    return colorToReturn;
};
